<template>
  <section
    :class="[
      `header header_${type}`,
      {
        header_spaced: spaced,
      },
    ]"
  >
    <div class="header__content">
      <div class="header__title">
        <slot name="title" />
      </div>
      <div class="header__subTitle" v-if="$slots.subTitle">
        <slot name="subTitle" />
      </div>
    </div>
    <div v-if="$slots.addons" class="header__addons">
      <slot name="addons" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Header',
  props: {
    type: {
      type: String,
      default: 'h1',
    },
    spaced: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  $root: &;
  // width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 0%;
  gap: 8px;

  &_h1 {
    #{$root}__title {
      @include h1;
    }
  }
  &_h2 {
    #{$root}__title {
      @include h2;
    }
  }
  &_h3 {
    #{$root}__title {
      @include h3;
    }
  }
  &_h4 {
    #{$root}__title {
      @include h4;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__subTitle {
    font-weight: $font-weight-md;
    font-size: $font-size-md;
    color: $color-grey-3;
  }

  &_spaced {
    #{$root}__title {
      flex: 1;
    }
  }
}
</style>
